import { styled, Button, DialogContent, Grid, Theme } from '@material-ui/core';
import { StyledDialog } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';

export const CloseButton = styled(Button)({
  position: 'absolute',
  top: '20px',
  right: '20px',
  cursor: 'pointer',
  minWidth: 'unset',
  borderRadius: '100%',
  width: 30,
  height: 30,
  background: 'none',
});

export const CustomDialog = styled(StyledDialog)({
  '&.paper': {
    minWidth: '85%',
    minHeight: '90%',
  },
  '& .MuiDialog-paperWidthSm': {
    maxWidth: '485px !important',
    minHeight: '611px !important',
  },
});

export const CustomDialogContent = styled(DialogContent)({
  padding: '40px 70px 50px!important',
  background: '#0d1117',
  display: 'flex',
  flexDirection: 'column',
  height: 630,
});

export const Header = styled('div')({
  marginBottom: 30,
  textAlign: 'center',
});

export const Content = styled(Grid)({
  '& > div:not(:last-child)': {
    marginBottom: 10,
  },

  '& .MuiOutlinedInput-root': {
    height: '50px!important',
    fontSize: 14,
    background: '#0e1319',
  },

  '& .MuiFormLabel-root': {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
    letterSpacing: '1px',
    alignItems: 'center',
    color: '#c2ccd8',

    '& .MuiBox-root': {
      padding: '2px 4px 1px 5px',
      border: '1px solid',
      borderRadius: '100%',
      fontSize: '12px',
    },
  },

  '& .MuiSelect-iconOutlined': {
    right: '0',
    top: '22px',
  },

  '& .MuiSelect-iconOpen': {
    top: '2px',
    right: '13px',
  },
});

export const TwoColumn = styled(Grid)({
  display: 'flex',
  gap: 15,
});

export const CheckboxContainer = styled(Grid)({
  letterSpacing: 0.4,
  marginTop: 10,

  '& .MuiTypography-root': {
    fontSize: 15,
  },
});

export const ActionsContainer = styled('div')({
  marginTop: 'auto',
  display: 'flex',
  gap: 15,
});

export const CustomButton = styled(Button)<Theme, { $variant?: string }>(({ $variant }) => ({
  borderRadius: 5,
  background: $variant === 'primary' ? COLORS.PRIMARY : $variant === 'connect' ? '#0f1621' : '#0c121b',
  border: '1px solid',
  borderColor: $variant === 'delete' ? COLORS.DANGER : COLORS.PRIMARY,
  height: 44,
  fontSize: $variant === 'connect' ? 14 : 16,
  margin: $variant === 'connect' ? '10px 0 20px' : 0,
}));
